import actions from '../../actionTypes';

export default triggers => {
  return {
    type: actions.SET_TRIGGERS,
    triggers
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/setTriggers.js